<template>
  <v-container>
    <v-row no-gutters justify="center">
      <v-col cols="12" sm="8" class="px-2" style="max-width: 600px">
        <div
          class="flip-card mt-4"
          :class="toggleCard ? 'flipped' : ''"
          style="font-size: 14px"
          @click="onClickCard"
        >
          <div
            class="flip-card-inner"
            :class="flipType == 'x' ? 'inner-flip-x' : 'inner-flip-y'"
          >
            <!-- Front -->
            <div
              class="flip-card-front d-flex flex-column"
              :class="setEffectCard()"
              :style="{
                background: ['none'].includes(this.effect)
                  ? setBackgoundBox()
                  : '',
                '--card-color': this.cardColor,
              }"
            >
              <input
                @change="onFileUpload"
                type="file"
                id="upload"
                ref="theFile"
                style="display: none"
                accept="image/png, image/gif, image/jpeg"
              />

              <memberCardBgMark v-if="!cardImage" :type="cardMarkType" />

              <v-container
                style="z-index: 1; height: 100%"
                :style="{
                  display: displayHide ? 'none' : '',
                }"
              >
                <v-row class="ma-0 flex-nowrap">
                  <v-col
                    cols="auto"
                    style="width: calc(100% - 100px)"
                    :style="{
                      color: `${getFontColorBasedOnBg(
                        customer.level_color || '#cd7f31',
                        'bw'
                      )} !important`,
                    }"
                  >
                    <v-row no-gutters>
                      <p
                        class="label-name text-body-2 mb-0 font-weight-medium text-center"
                      >
                        {{ customer.name }}
                        {{ customer.surname }}
                      </p>
                    </v-row>
                    <v-row
                      v-if="user_point_type == 'card'"
                      no-gutters
                      align="center"
                    >
                      <div
                        class="pa-0 mt-1 px-1"
                        style="
                          width: fit-content;
                          max-width: 100%;
                          border-radius: 30px;
                          background-color: beige;
                          background: rgba(255, 255, 255, 0.12);
                          border: 2px solid rgba(255, 255, 255, 0.25);
                        "
                        @click="goToMypoint($event, 'all')"
                      >
                        <div
                          v-if="
                            Array.isArray(customer.point) &&
                            customer.point.length > 0
                          "
                          class="d-flex align-center justify-center"
                          style="gap: 4px"
                        >
                          <PointSymbol
                            :type="customer.point[0].point_type_type"
                            :symbol="customer.point[0].point_type_symbol"
                            :color="customer.point[0].point_type_color"
                            :is_display="true"
                            :outlined_box="false"
                            :size="32"
                          />
                          <div style="font-size: 20px; font-weight: bold">
                            {{ customer.point[0].point | commaPoint }}
                          </div>
                          <div class="text-truncate" style="font-size: 16px">
                            {{ customer.point[0].point_type_name }}
                          </div>
                          <div>
                            <v-icon color="white" small>
                              mdi-chevron-right
                            </v-icon>
                          </div>
                        </div>
                      </div>
                    </v-row>
                  </v-col>
                  <v-col cols="auto">
                    <div @click="goToEditProfile" style="cursor: pointer">
                      <v-badge
                        bordered
                        overlap
                        icon="mdi-pencil"
                        :color="site.color"
                      >
                        <v-avatar size="60">
                          <v-img
                            :lazy-src="defaultImage"
                            :src="profileImage"
                            @error="onImageError()"
                          ></v-img>
                        </v-avatar>
                      </v-badge>
                    </div>
                  </v-col>
                </v-row>
                <div
                  v-if="
                    user_point_type == 'card' &&
                    dataExpireCoin.site_use_expire == 'Y' &&
                    Array.isArray(dataExpireCoin.total_expire_point) &&
                    dataExpireCoin.total_expire_point.length > 0 &&
                    dataExpireCoin.total_expire_point[0].point > 0 &&
                    !checkDate(dataExpireCoin.point_expire_date)
                  "
                  class="ma-0 px-3"
                  style="position: absolute; bottom: 16px; right: 0px"
                >
                  <v-col cols="12" class="d-flex justify-center px-1 py-0">
                    <v-card elevation="0" color="white" dark class="px-4 py-2">
                      <v-card-text
                        class="black--text py-1"
                        @click="goToMypoint($event, 'expiring')"
                      >
                        <v-row>
                          <v-col
                            cols="auto"
                            align-self="center"
                            style="padding: 0"
                          >
                            <div class="mr-2">
                              <PointSymbol
                                :type="
                                  dataExpireCoin.total_expire_point[0]
                                    .point_type_type
                                "
                                :symbol="
                                  dataExpireCoin.total_expire_point[0]
                                    .point_type_symbol
                                "
                                :color="
                                  dataExpireCoin.total_expire_point[0]
                                    .point_type_color
                                "
                                :is_display="true"
                                :outlined_box="false"
                                :size="40"
                              />
                            </div>
                          </v-col>
                          <v-col
                            cols="auto"
                            align-self="center"
                            style="width: calc(100% - 76px)"
                          >
                            <v-row class="ma-0 align-center">
                              <h2 class="mr-1" :style="{ color: site.color }">
                                {{
                                  dataExpireCoin.total_expire_point[0].point
                                    | commaPoint
                                }}
                              </h2>
                              <span class="text-truncate">
                                {{
                                  dataExpireCoin.total_expire_point[0]
                                    .point_type_name
                                }}
                              </span>
                            </v-row>
                            <v-row class="ma-0 align-center">
                              {{ $t("expiredAt") }}
                              {{
                                dataExpireCoin.point_expire_date | formatDate
                              }}
                            </v-row>
                          </v-col>
                          <v-icon color="grey" small style="margin-left: 10px">
                            mdi-chevron-right
                          </v-icon>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </div>
              </v-container>
            </div>

            <!-- Back -->
            <div
              class="flip-card-back"
              :class="
                (flipType == 'x' ? 'flip-x' : 'flip-y') + ' ' + setEffectCard()
              "
              :style="{
                background: ['none'].includes(this.effect)
                  ? setBackgoundBox()
                  : '',
                '--card-color': this.cardColor,
              }"
            >
              <memberCardBgMark v-if="!cardImage" :type="cardMarkType" />

              <v-container style="position: absolute; z-index: 1; height: 100%">
                <v-row no-gutters justify="center">
                  <v-col
                    cols="auto"
                    :style="{
                      color: `${getFontColorBasedOnBg(
                        customer.level_color || '#cd7f31',
                        'bw'
                      )} !important`,
                    }"
                  >
                    <p class="text-h6 font-weight-medium mb-0">
                      {{ $t("code") }} : {{ customer.code }}
                    </p>
                  </v-col>
                </v-row>
                <v-row no-gutters justify="center" class="mt-2">
                  <v-col cols="auto">
                    <div
                      class="d-flex justify-center align-center"
                      style="
                        background-color: #ffffff;
                        border-radius: 8px;
                        padding: 10px 10px 2px 10px;
                      "
                    >
                      <QrcodeVue
                        :value="setQRCodeCustomer()"
                        level="L"
                        :ref="'qrcode'"
                        style="width: 100%; height: 100%"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import {
  adjustHslBrightness,
  getFontColorBasedOnBg,
} from "@/config/general-function";
import memberCardBgMark from "./member-card-bg-mark.vue";
import QrcodeVue from "qrcode.vue";
import PointSymbol from "../point/point-symbol.vue";

export default {
  components: { QrcodeVue, memberCardBgMark, PointSymbol },
  props: ["site", "customer", "url", "dataExpireCoin", "user_point_type"],
  data() {
    return {
      toggleCard: false,
      flipType: "y",
      cardMarkType: 2,
      displayHide: false,
      effect: "none", // none, pure-sweep
      cardColor: "",
      cardImage: "",
      profileImage: "",
    };
  },
  computed: {
    varProfileImage() {
      return this.url || this.customer.image;
    },
    defaultImage() {
      return require("@/assets/images/user.svg");
    },
  },
  created() {
    this.cardColor = this.customer.level_color || "#FFFFFF";
    this.cardImage = this.customer.level_image_cover_card || "";
    if (!this.cardImage) {
      this.effect = "pure-sweep";
    }
  },
  methods: {
    onImageError() {
      this.profileImage = this.defaultImage;
    },
    onClickCard() {
      this.toggleCard = !this.toggleCard;
    },
    onFileUpload(event) {
      event.stopPropagation();
      this.$emit("onFileUpload", event);
    },
    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    setBackgoundBox() {
      const _color = this.cardColor;
      const darken = adjustHslBrightness(_color, -20);
      const lighten = adjustHslBrightness(_color, 20);
      let _style = `linear-gradient(120deg, ${lighten}, ${_color}, ${darken})`;
      if (this.cardImage) {
        _style = `url("${this.cardImage}") center / cover no-repeat`;
      }
      return _style;
    },
    setEffectCard() {
      let name = this.effect;
      if (["none"].includes(this.effect)) {
        name = "";
      }
      return name;
    },
    setQRCodeCustomer() {
      let qrValue = this.customer.code;
      const detail = {
        type: "customer",
        id: this.customer.id,
        code: this.customer.code,
      };
      qrValue = JSON.stringify(detail);
      return qrValue;
    },
    checkDate(date) {
      let dateMoreThan1Year = moment().add(1, "year").format("YYYY-MM-DD");
      return moment(date).isAfter(dateMoreThan1Year);
    },
    goToEditProfile(event) {
      event.stopPropagation();
      this.$router.push({ name: "edit-profile" });
    },
    changeColorCard(event) {
      event.stopPropagation();
      const r = Math.floor(Math.random() * 127 + 127);
      const g = Math.floor(Math.random() * 127 + 127);
      const b = Math.floor(Math.random() * 127 + 127);
      const toHex = (c) => {
        // ใช้ toString(16) เพื่อแปลงเป็นเลขฐาน 16
        // ใช้ padStart(2, "0") เพื่อให้ได้ 2 หลักเสมอ เช่น 10 จะเป็น "0a"
        return c.toString(16).padStart(2, "0");
      };
      // นำค่าที่แปลงแล้วของ R, G, B มาต่อกัน
      const color_ = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
      this.cardColor = color_;
    },
    goToMypoint(event, type) {
      event.stopPropagation();
      this.$router.push({
        name: "my-point",
        query: { type },
      });
    },
  },
  watch: {
    toggleCard: {
      handler() {
        // ต้องทำแบบนี้เนื่องจาก css มีปัญหาใน browser safari
        if (this.toggleCard) {
          this.displayHide = true;
        } else {
          setTimeout(() => {
            this.displayHide = false;
          }, 100);
        }
      },
      deep: true,
      immediate: true,
    },
    varProfileImage: {
      handler() {
        this.profileImage = this.varProfileImage;
      },
      deep: true,
      immediate: true,
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("DD MMM YYYY");
    },
  },
};
</script>

<style scoped>
.label-name {
  line-height: 1.3;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.flip-card {
  background-color: transparent;
  width: 100%;
  aspect-ratio: 1.75 / 1;
  perspective: 1000px;
  cursor: pointer;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  transition: transform 0.6s;
  transform-style: preserve-3d;
}

.flip-card.flipped .flip-card-inner.inner-flip-x {
  transform: rotateX(180deg);
}

.flip-card.flipped .flip-card-inner.inner-flip-y {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
}

.flip-card-back {
  background: #ffffff;
}

.flip-x {
  transform: rotateX(180deg);
}

.flip-y {
  transform: rotateY(180deg);
}

.pure-sweep {
  /* ใส่สีพื้นหลังหลักจากตัวแปรของคุณ */
  background-color: var(--card-color) !important;

  /* สร้างลำแสงซ้อนทับบนสีพื้นหลัง */
  background-image: linear-gradient(
    120deg,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0.2) 40%,
    rgba(255, 255, 255, 0.7) 50%,
    rgba(255, 255, 255, 0.2) 60%,
    rgba(255, 255, 255, 0) 70%
  ) !important;

  /* สำคัญ: ขนาดต้องใหญ่เพื่อให้มีระยะวิ่ง และ Repeat ต้องเป็น no-repeat */
  background-size: 300% 100% !important;
  background-repeat: no-repeat !important;

  /* ใช้ Animation วิ่งจากซ้ายสุดไปขวาสุด */
  animation: pureSweep 4s cubic-bezier(0.4, 0, 0.2, 1) infinite !important;

  /* เพิ่ม transition ให้สีพื้นหลังเวลากดสุ่มแล้วดูสมูท */
  transition: background-color 0.4s ease;
}

@keyframes pureSweep {
  0% {
    /* เริ่มต้นที่ตำแหน่งซ้ายสุด (นอกเขตการมองเห็น) */
    background-position: 200% 0%;
  }
  100% {
    /* วิ่งไปจบที่ตำแหน่งขวาสุด (พ้นเขตการมองเห็น) */
    background-position: -100% 0%;
  }
}
</style>
